import Vue from 'vue';
import {
  Button,
  Input,
  Row,
  Col,
  Radio,
  RadioButton,
  Checkbox,
  CheckboxButton,
  RadioGroup,
  TimeSelect,
  DatePicker,
  Form,
  FormItem,
  Select,
  Option
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

locale.use(lang);

Vue.use(Button);
Vue.use(Input);
Vue.use(Row);
Vue.use(Col);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(RadioGroup);
Vue.use(TimeSelect);
Vue.use(DatePicker);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
